<template>
  <div v-if="shop && redeemWarnings">
    <b-container fluid>
      <!-- Logo -->
      <b-row>
        <b-col cols="12">
          <ShopLogo :shop="shop" />
        </b-col>
      </b-row>

      <!-- Warnings -->
      <b-row>
        <b-col cols="12">
          <div class="redeem-warning-list mb-4">
            <div
              v-for="warning in redeemWarnings"
              :key="warning"
              v-html="sanitizeHtmlContent(warning)"
            />
          </div>
        </b-col>
      </b-row>

      <!-- Buttons -->
      <b-row>
        <b-col xs="12" sm="12" class="mb-3">
          <b-button class="accept-warnings-btn" block variant="primary" @click="$emit('next')">
            <span v-html="forwardButtonText" />
          </b-button>
        </b-col>
        <b-col xs="12" sm="12" class="mb-3">
          <b-button block variant="link" @click="$bvModal.hide('shop-details')">
            <span v-html="backButtonText" />
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import ShopLogo from '~shopDetails/ShopLogo';

export default {
  components: { ShopLogo },

  props: {
    /* Shop as object */
    shop: {
      type: Object,
      default: null,
    },
  },

  computed: {
    ...mapState({
      form: (state) => state.customer.form,
    }),

    ...mapGetters({
      voucherCategoryId: 'getVoucherCategoryId',
    }),

    backButtonText() {
      return this.voucherCategoryId === 6 ? this.$t('wgs.std.noGoBackToOverview') : this.$t('wgs.std.noGoBack');
    },
    forwardButtonText() {
      return this.voucherCategoryId === 6 ? this.$t('wgs.std.readHintsDonateNow') : this.$t('wgs.std.readHints');
    },
    redeemWarnings() {
      const redeemWarnings = [];
      // filter redeem warnings for redeem value
      this.shop.redeemWarnings.forEach((warning) => {
        if (!warning.valueInCent || warning.valueInCent === this.form.redeemValue) {
          redeemWarnings.push(warning.text);
        }
      });
      return redeemWarnings;
    },
  },

  mounted() {
    if (!this.shop.redeemWarnings) {
      this.$emit('next');
    }
  },

  methods: {
    sanitizeHtmlContent(html) {
      return this.$sanitize ? this.$sanitize(html) : html;
    },
  },
};
</script>

<style lang="scss">
.redeem-warning-list {
  ol,
  ul,
  dl {
    padding-left: 1.35em;
  }

  p {
    margin-bottom: 0;
  }
}
</style>
